import { ReadyRoomShell } from "@/components/vyllage/ReadyRoomShell";

/** Admin sprite library browser. */
export function SpritesPage() {
  return <ReadyRoomShell panel="sprites" />;
}
